import { intersectionObserver } from './intersection-observer';
import { formatLocalDateShortcut } from '@fastcampus/util/src/date';

export default (w, d) => {
  const $defaultProduct = document.querySelector('#main');
  const initPrice = () => {
    const {
      productId,
      hasProducts = 0,
      listPrice,
      salePrice,
      splitPrice = null,
      productSaleDueDate,
      productDiscountAmount,
      productTitle,
      discountPercent,
      hideAt,
    } = $defaultProduct.dataset;
    [...d.querySelectorAll('.fc-layout-901')].forEach(($layout) => {
      if (hasProducts > 0) {
        [...$layout.querySelectorAll('.sale-due-date')].forEach(($item) => {
          if (productSaleDueDate !== 'false') {
            $item.innerText = productSaleDueDate;
          } else {
            $item.style.display = 'none';
          }
        });
        $layout.querySelector('.product-title').innerText = productTitle;
        $layout.querySelector('.list-price.sale').innerText = listPrice;
        $layout.querySelector('.sale-price.sale').innerText = salePrice;

        const $splitPrice = $layout.querySelector('.split-price');

        // 그래프를 사용안하는 경우
        if ($splitPrice) {
          if (splitPrice) {
            $splitPrice.innerText = splitPrice;
          } else {
            $splitPrice.style.display = 'none';
          }
        }

        $layout.querySelector('.in-twelve-installments.sale').innerText = splitPrice;
        $layout.querySelector('.payment-btn').setAttribute('href', `/products/${productId}`);

        if (discountPercent > '0') {
          $layout.querySelector('.payment-card').classList.remove('without-discount');
          $layout.querySelector('.discount-percent').innerText = discountPercent;
        } else {
          $layout.querySelector('.payment-card').classList.add('without-discount');
          $layout.querySelector('.discount-percent').style.display = 'none';
        }

        if (splitPrice) {
          $layout.querySelector('.payment-card').classList.add('has-installment');
        } else {
          $layout.querySelector('.payment-card').classList.remove('has-installment');
        }
      } else {
        $layout.style.display = 'none';
      }

      const $chartContainer = $layout.querySelector('.chart-container');

      if ($chartContainer) {
        intersectionObserver($chartContainer, 'active');
      }
    });

    [...d.querySelectorAll('.fc-layout-902')].forEach(($layout) => {
      if (hasProducts === 'true' || hasProducts === '1') {
        $layout.querySelector('.container__list-price span').innerText = listPrice;
        $layout.querySelector('.container__sale-price span').innerText = salePrice;
        $layout.querySelector('.container__split-price span').innerText = splitPrice;
        $layout.querySelector('.container__enrollment-btn').setAttribute('href', `/products/${productId}`);
      } else {
        $layout.style.display = 'none';
      }
    });

    [...d.querySelectorAll('.fc-layout-909')].forEach(($layout) => {
      const innerLayout = $layout.querySelector('.container-fluid');
      const {
        dataset: { monthlyInstallment },
      } = innerLayout;

      const $barChartContainer = $layout.querySelector('.container__chart');

      if ($barChartContainer) {
        intersectionObserver($barChartContainer, 'chart-play');
      }

      if (Boolean(hasProducts) === true || Number(hasProducts) === 1) {
        const splitPrice = Math.floor(Number(salePrice.replace(',', '')) / Number(monthlyInstallment))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        $layout.querySelector('.container__title strong').innerText = `${formatLocalDateShortcut(hideAt)},`;
        $layout.querySelector('.list-price').innerText = listPrice;
        $layout.querySelector('.discount-price').innerText = productDiscountAmount;
        $layout.querySelector('.sale-price').innerText = salePrice;
        $layout.querySelector('.split-price strong').innerText = splitPrice;
      } else {
        $layout.style.display = 'none';
      }
    });
  };

  if ($defaultProduct) {
    initPrice();
  }
};
